import React, { useRef, useEffect, useState, Fragment } from "react";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  CircularProgress,
  Paper,
} from "@mui/material";
import Pagination from "components/Pagination";
import Colors from "assets/Style/Colors";
import { makeStyles } from "@mui/styles";
import { FontFamily } from "assets";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import InputField from "components/Input";
import VendorServices from "services/Vendor";
import { useAuth } from "context/UseContext";
import DropdownMenu from "components/DropDown";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function AdminRoutes() {
  const [selectedManifest, setselectedManifest] = useState(null);
  const [manifestOptions, setmanifestOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const [selectedItem, setSelecteditem] = useState(null);
  const [uploadInvoiceData, setUploadInvoiceData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelecteditem(null);
  };

  const contentRef = useRef(null);
  const { user } = useAuth();

  const {
    register,
    handleSubmit,
    getValues: getValues1,
    setValue,
    formState: { errors },
    watch,
  } = useForm();

  const tableHead = [
    "Sr.No",
    "Invoice Type",
    "Invoice No",
    "Upload Date",
    "Uploaded By",
    "Action",
  ];

  const module_types = [{ id: "vehicle_tt", name: "Vehicle TT" }];

  const [loader, setLoader] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filters
  const [filters, setFilters] = useState({});
  const [selectedValue, setSelectedValue] = useState("option1");

  const handleRadioChange = (value) => setSelectedValue(value);

  const [auctionHouses, setAuctionHouses] = useState();
  const [selectedAuctionHouses, setSelectedAuctionHouses] = useState("");

  const [openWhatsAppModal, setOpenWhatsAppModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteInvoiceId, setSelectedDeleteInvoiceId] = useState(0);

  const [permissions, setPermissions] = useState();
  const [invoiceDatas, setInvoiceDatas] = useState([]);
  const [searchTerm, setSearchTerm] = useState();

  // ---------- Data fetching ---------- //
  const getInvoiceData = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page || currentPage;
      const Limit = limit || pageLimit;
      const Filter = { ...filters, ...filter };

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        module_type: "vehicle_tt",
        page: Page,
        limit: Limit,
        user_id: user?.id,
        ...Filter,
      };

      const { data } = await VendorServices.getUploadedVendorInvoices(params);

      setUploadInvoiceData(data?.rows);
      setTotalCount(data?.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilter = async (data) => {
    setLoader(true);
    if (isSearching) return;

    setIsSearching(true);
    try {
      await getInvoiceData(1, "", data);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoader(false);
    }
  };

  useEffect(() => {
    getInvoiceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const getCleanUrl = (url) => {
    if (!url) return "";

    const index = url.indexOf("/invoices");
    if (index === -1) return url; // if "invoices" not found, return original

    return url.substring(index + 1); // remove leading slash
  };

  return (
    <>
      <Box component={"form"}>
        <Box sx={{ width: "100%" }}>
          <Grid container>
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  my: 3,
                  ml: 4,
                  mr: 8,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: Colors.charcoalGrey,
                    fontFamily: FontFamily.NunitoRegular,
                    textAlign: "left",
                  }}
                >
                  Vehicle TT Attachments
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} style={{ marginLeft: "35px" }}>
              <InputField
                size={"small"}
                label={"Search"}
                placeholder={"Search"}
                register={register("search", {
                  onChange: (e) => handleFilter({ search: e.target.value }),
                })}
              />
            </Grid>
          </Grid>
        </Box>

        <Grid container sx={{ borderRadius: "5px", m: 4, mt: 0 }}></Grid>

        <Box sx={{ m: 4, mb: 2 }}>
          {uploadInvoiceData ? (
            <Fragment>
              <Box className="pdf-show" sx={{ display: "none" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.NunitoRegular,
                      mb: 2,
                    }}
                  >
                    Export Vehicle Payments
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: 400,
                      fontSize: "12px",
                      mt: 1.5,
                      color: Colors.charcoalGrey,
                    }}
                  >
                    <span>Date: &nbsp;&nbsp;</span>
                    {moment().format("MM-DD-YYYY")}
                  </Box>
                </Box>
              </Box>

              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                  borderRadius: 2,
                }}
                className="table-box"
              >
                <Table stickyHeader sx={{ minWidth: 500 }}>
                  <TableHead>
                    <TableRow>
                      {tableHead.map((item, index) => (
                        <Cell className="pdf-table" key={index}>
                          {item}
                        </Cell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!loader ? (
                      uploadInvoiceData.length > 0 ? (
                        <Fragment>
                          {uploadInvoiceData.map((item, index) => {
                            const findModule = module_types?.find(
                              (val) => val?.id === item?.module_type
                            );
                            return (
                              <Row
                                key={index}
                                sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                              >
                                <Cell className="pdf-table">
                                  {index + 1 ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {findModule?.name ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.invoice_no ?? "-"}
                                </Cell>

                                <Cell className="pdf-table">
                                  {moment(item?.created_at).format(
                                    "DD-MM-YYYY"
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.upload_by?.name ?? "-"}
                                </Cell>

                                <Cell className="pdf-table">
                                  {/* {item?.response_url ? (
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        downloadAllAttachments(
                                          item?.response_url
                                        )
                                      }
                                    >
                                      <FiDownload
                                        color={Colors.primary}
                                        size={25}
                                      />
                                    </div>
                                  ) : (
                                    <FiDownload color="gray" size={25} />
                                  )} */}
                                  <Box
                                    component={"div"}
                                    className="pdf-hide"
                                    sx={{ gap: "16px !important" }}
                                  >
                                    <DropdownMenu
                                      item={item}
                                      permissions={permissions}
                                      navigate={navigate}
                                      ErrorToaster={ErrorToaster}
                                      Colors={Colors}
                                      isOpen={activeMenu === item.id}
                                      onToggle={(isOpen) =>
                                        handleMenuToggle(item.id, isOpen)
                                      }
                                      downloadVendorInvoice={() => {
                                        downloadAllAttachments(
                                          process.env.REACT_APP_ENV === "stg"
                                            ? item?.response_url
                                            : process.env
                                                .REACT_APP_IMAGE_BASE_URL +
                                                "invoices/" +
                                                getCleanUrl(item?.response_url)
                                        );
                                      }}
                                      id={item?.id}
                                    />
                                  </Box>
                                </Cell>
                              </Row>
                            );
                          })}
                        </Fragment>
                      ) : (
                        <Row>
                          <Cell
                            colSpan={tableHead?.length + 1}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            No Data Found
                          </Cell>
                        </Row>
                      )
                    ) : (
                      <Row>
                        <Cell
                          colSpan={tableHead?.length + 2}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          <Box className={classes.loaderWrap}>
                            <CircularProgress />
                          </Box>
                        </Cell>
                      </Row>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) =>
                  getInvoiceData(1, size.target.value)
                }
                tableCount={uploadInvoiceData?.length}
                totalCount={totalCount}
                onPageChange={(page) => getInvoiceData(page, "")}
              />
            </Fragment>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
}
export default AdminRoutes;
